import { CSSProperties } from "react";
import { Spinner } from "reactstrap";

interface SpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  color?: "secondary" | "primary" | "dark" | "danger" | "white";
  style?: CSSProperties;
  className?: string;
}

const AppSpinner = ({
  size = "sm",
  color = "primary",
  style = {},
  className = "",
}: SpinnerProps) => {
  return (
    <Spinner size={size} color={color} style={style} className={className} />
  );
};

export default AppSpinner;
